import React from 'react'
import PostMeta from '@/components/Featured/Mundial62/Posts/PostMeta'
import PostFormattedTitle from '@/components/Featured/Mundial62/Posts/PostFormattedTitle'
import PostExcerpt from '@/components/Featured/Mundial62/Posts/PostExcerpt'

const PlantelHeader = ({ ...props }) => {
  return (
    <div {...props}>
      <PostFormattedTitle
        title="Los 22 que marcaron una época"
        pretitle=""
        posttitle="que marcaron una época"
        largesttitle="Los 22"
      />
      <PostExcerpt excerpt="Ocho de los 22 seleccionados pertenecían a Universidad de Chile, más de un tercio de la selección mundialista. Honorino Landa fue el primero en partir con tan solo 44 años. Y de los siete futbolistas que aún viven, Braulio Musso es el que más calendarios vio pasar: 92. Aquí, la ficha de los 22 jugadores que estuvieron ese mundial." />
      <PostMeta
        slug="los-22-que-marcaron-una-epoca"
        author="Laboratorio de Contenidos de Marca"
      />
    </div>
  )
}

export default PlantelHeader
